import React, { useContext } from "react";

import { UpgradeIcon } from "~/billing";
import { trackConversion } from "~/lib/ab/growthbook";
import MeetingPhaseContext from "~/stream/MeetingPhaseContext";
import useStartTourOnSight from "~/welcomeChecklist/useStartTourOnSight";

import { FLOATING_RECORDING_CONTROLS_EXPERIMENT_KEY } from "./FloatingRecordingControls";
import { RecordingOptionsContext } from "./PreMeetingControls";
import { ControlButton } from "./SharedComponents";

import oldStyles from "~/stream/NoteHeader/RecordingControls/StartAndAutoRecordingControls.module.css";

import styles from "./FloatingRecordingControls.module.css";

export default function StartRecordingButton({
	onMouseEnterTarget,
	onMouseLeaveTarget,
	disabled,
}: {
	onMouseEnterTarget: (event: React.MouseEvent<HTMLElement>) => void;
	onMouseLeaveTarget: () => void;
	disabled: boolean;
}) {
	const visibilityRef = useStartTourOnSight("FLOATING_RECORDING_CONTROLS");
	const { startRecording: startRecordingFn, mustUpgradeBeforeRecording: mustUpgrade } = useContext(MeetingPhaseContext);

	const { recordingMode, recordingMediaType, selectedConferenceCall } = useContext(RecordingOptionsContext);

	const startRecording = React.useCallback(() => {
		trackConversion(FLOATING_RECORDING_CONTROLS_EXPERIMENT_KEY);
		return startRecordingFn(recordingMode, selectedConferenceCall?.conferenceCall ?? null, {
			overrideAutoRecord: true,
			mediaType: recordingMediaType,
		});
	}, [startRecordingFn, recordingMode, recordingMediaType, selectedConferenceCall]);

	return (
		<ControlButton
			onClick={startRecording}
			data-tour-tooltip-target="record-button"
			data-test-id="start-recording-in-note-header"
			onMouseEnter={onMouseEnterTarget}
			onMouseLeave={onMouseLeaveTarget}
			disabled={disabled}
		>
			{mustUpgrade ? <UpgradeIcon /> : <span className={styles.recordNowIcon} />}
			&ensp;
			{/* Placing the ref here since this element is used in all variations of this button */}
			<b ref={visibilityRef} className={oldStyles.nowrap}>
				Record now
			</b>
		</ControlButton>
	);
}
